<template lang="pug">
  d2-container
      el-row()
        el-col()
          el-form(:inline='true', :model='dataForm')
            el-form-item
              el-button(v-if="isAuth('sys:menu:save')", type='primary', @click='addOrUpdateHandle()') 新增
      el-row()
        el-col()
          el-table(:data='dataList', border='', v-loading='dataListLoading', style='width: 100%;')
            table-tree-column(prop='name', header-align='center', treekey='menuId', width='190', label='名称')
            el-table-column(prop='parentName', header-align='center', align='center', width='120', label='上级菜单')
              template(slot-scope='scope')
                span(v-if="scope.row.parentName === ''")  -
                span(v-else='')  {{ scope.row.parentName }}
            el-table-column(header-align='center', align='center', label='图标' width='70')
              template(slot-scope='scope')
                i(:class="'fa fa-' + scope.row.icon")
            el-table-column(prop='type', header-align='center', align='center', label='类型')
              template(slot-scope='scope')
                span(v-if='scope.row.type === 0', size='small') 目录
                span(v-else-if='scope.row.type === 1', size='small', type='success') 菜单
                span(v-else-if='scope.row.type === 2', size='small', type='info') 按钮
            el-table-column(prop='orderNum', header-align='center', align='center', label='排序号')
            el-table-column(prop='url', header-align='center', align='center', width='150', :show-overflow-tooltip='true', label='菜单URL')
            //- el-table-column(prop='perms', header-align='center', align='center', width='150', :show-overflow-tooltip='true', label='授权标识')
            el-table-column( header-align='center', align='center', width='100', label='操作')
              template(slot-scope='scope')
                el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse")
                            el-submenu(index="1")
                                template(slot="title")
                                    i(class="el-icon-more" style='color:#02B90D;')
                                el-menu-item-group()
                                  el-menu-item(v-if="isAuth('sys:menu:update')", type='text',  @click='addOrUpdateHandle(scope.row.menuId)') 修改
                                  el-menu-item(v-if="isAuth('sys:menu:delete')", type='text', @click='deleteHandle(scope.row.menuId)') 删除
          add-or-update(v-if='addOrUpdateVisible', ref='addOrUpdate', @refreshdatalist='getDataList')
</template>

<script>
import TableTreeColumn from '@/components/table-tree-column'
import AddOrUpdate from './menu-add-or-update-copy'
import { treeDataTranslate } from '@/util'
export default {
  data () {
    return {
      isCollapse: true,
      dataForm: {},
      dataList: [],
      dataListLoading: false,
      addOrUpdateVisible: false
    }
  },
  components: {
    TableTreeColumn,
    AddOrUpdate
  },
  created () {
    this.getDataList()
  },
  methods: {
      //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/sys/menu/list'),
        method: 'get'
      }).then(data => {
        console.log(data)
        this.dataList = treeDataTranslate(data, 'menuId')
        this.dataListLoading = false
      })
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      console.log(111111111111)

      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle (id) {
      this.$confirm(`确定对[id=${id}]进行[删除]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl(`/sys/menu/delete/${id}`),
            method: 'post'
          }).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style>
/* 操作三点 菜单样式 */
@import'../../css/opr3dot.css';
</style>
